export default "__VITE_ASSET__BORrcsji__"